/* FAQ — motion éditorial "fil d'or". Vanilla : IO + WAAPI + rAF, zéro dépendance.
   Tout est coupé sous prefers-reduced-motion / réglage thème (window.mwSettings). */
(function () {
  'use strict';
  if (window.__mwFaqxInit) return; /* chargé une fois même si plusieurs sections l'incluent */
  window.__mwFaqxInit = true;

  var EASE = 'cubic-bezier(0.215, 0.61, 0.355, 1)'; /* power3.out */
  var reduce =
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    (window.mwSettings && window.mwSettings.motionEnabled === false);

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- 1 · Hero : reveal mot par mot ---------- */
  function splitWords(el) {
    var frag = document.createDocumentFragment();
    function wrapWord(word, tag) {
      var w = document.createElement('span');
      w.className = 'mw-faqx-w';
      var wi = document.createElement('span');
      wi.className = 'mw-faqx-wi';
      if (tag) {
        var t = document.createElement(tag);
        t.textContent = word;
        wi.appendChild(t);
      } else {
        wi.textContent = word;
      }
      w.appendChild(wi);
      return w;
    }
    function walk(node, tag) {
      if (node.nodeType === 3) {
        var parts = node.textContent.split(/(\s+)/);
        parts.forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) frag.appendChild(document.createTextNode(' '));
          else frag.appendChild(wrapWord(p, tag));
        });
      } else if (node.nodeType === 1) {
        Array.prototype.slice.call(node.childNodes).forEach(function (c) {
          walk(c, node.tagName.toLowerCase());
        });
      }
    }
    Array.prototype.slice.call(el.childNodes).forEach(function (n) { walk(n, null); });
    el.textContent = '';
    el.appendChild(frag);
    return el.querySelectorAll('.mw-faqx-wi');
  }

  function initHero() {
    var title = document.querySelector('[data-faqx-split]');
    if (!title) return;
    if (reduce) return; /* texte déjà visible, rien à faire */
    var words = splitWords(title);
    words.forEach(function (wi, i) {
      wi.animate(
        [
          { transform: 'translateY(115%)', filter: 'blur(6px)', opacity: 0.6 },
          { transform: 'translateY(0)', filter: 'blur(0px)', opacity: 1 }
        ],
        { duration: 900, delay: 140 + i * 80, easing: EASE, fill: 'both' }
      );
    });
    /* kicker + intro suivent le titre — double rAF pour garantir la transition */
    var trail = document.querySelectorAll('.mw-faqx-hero [data-faqx-reveal]');
    trail.forEach(function (el, i) {
      el.style.transitionDelay = (0.45 + i * 0.15) + 's';
      el.addEventListener('transitionend', function te() {
        el.style.transitionDelay = '';
        el.removeEventListener('transitionend', te);
      });
    });
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        trail.forEach(function (el) { el.classList.add('is-in'); });
      });
    });
  }

  /* ---------- 2 · Reveals au scroll ---------- */
  function initReveals() {
    var els = document.querySelectorAll('[data-faqx-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 3 · Scroll-spy nav d'ancres ---------- */
  function initSpy() {
    var nav = document.querySelector('.mw-faqx-nav');
    var groups = document.querySelectorAll('[data-faqx-group]');
    if (!nav || !groups.length || !('IntersectionObserver' in window)) return;
    var links = {};
    nav.querySelectorAll('a[href^="#"]').forEach(function (a) {
      links[a.getAttribute('href').slice(1)] = a;
    });
    function activate(id) {
      Object.keys(links).forEach(function (k) {
        links[k].classList.toggle('is-active', k === id);
        if (k === id) links[k].setAttribute('aria-current', 'true');
        else links[k].removeAttribute('aria-current');
      });
    }
    var current = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { current = e.target.id; activate(current); }
      });
    }, { rootMargin: '-25% 0px -65% 0px', threshold: 0 });
    groups.forEach(function (g) { io.observe(g); });
    if (groups[0]) activate(groups[0].id);
  }

  /* ---------- 4 · Accordéons <details> animés + deep links ---------- */
  function initAccordions() {
    var stream = document.querySelector('[data-faqx-stream]');
    if (!stream) return;
    var single = stream.getAttribute('data-faqx-single') === 'true';
    var items = Array.prototype.slice.call(stream.querySelectorAll('details[data-faqx-item]'));

    function close(d, animate) {
      var body = d.querySelector('.mw-faqx-item__body');
      if (!animate || reduce || !body.animate) { d.open = false; return; }
      if (d.__anim) d.__anim.cancel();
      d.__anim = body.animate(
        [{ height: body.offsetHeight + 'px' }, { height: '0px' }],
        { duration: 450, easing: EASE }
      );
      d.__anim.onfinish = function () { d.open = false; d.__anim = null; };
    }
    function open(d, animate) {
      if (single) items.forEach(function (o) { if (o !== d && o.open) close(o, animate); });
      d.open = true;
      var body = d.querySelector('.mw-faqx-item__body');
      if (!animate || reduce || !body.animate) return;
      if (d.__anim) d.__anim.cancel();
      d.__anim = body.animate(
        [{ height: '0px' }, { height: body.offsetHeight + 'px' }],
        { duration: 550, easing: EASE }
      );
      d.__anim.onfinish = function () { d.__anim = null; };
    }

    items.forEach(function (d) {
      var summary = d.querySelector('summary');
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.__anim) return;
        if (d.open) close(d, true); else open(d, true);
      });
    });

    /* lien profond #question-slug (ou #groupe) */
    function openFromHash() {
      var id = decodeURIComponent(location.hash.replace('#', ''));
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      if (target.matches && target.matches('details[data-faqx-item]')) open(target, false);
      window.setTimeout(function () {
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }, 60);
    }
    window.addEventListener('hashchange', openFromHash);
    openFromHash();

    /* copier le lien d'une question */
    stream.querySelectorAll('[data-faqx-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-faqx-copy');
        var url = location.origin + location.pathname + '#' + id;
        var label = btn.textContent;
        function done() {
          btn.textContent = btn.getAttribute('data-copied-label') || label;
          window.setTimeout(function () { btn.textContent = label; }, 2000);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function () {});
        }
      });
    });
  }

  /* ---------- 5 · Parallaxe douce sur les bandes média ---------- */
  function initParallax() {
    if (reduce) return;
    var els = document.querySelectorAll('[data-faqx-parallax]');
    if (!els.length) return;
    var raf = null;
    function update() {
      raf = null;
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh; /* -0.5 → 0.5 environ */
        var y = Math.max(-6, Math.min(6, -p * 8)); /* buffer inset -8% jamais dépassé */
        el.style.transform = 'translate3d(0,' + y.toFixed(2) + '%,0)';
      });
    }
    function queue() { if (!raf) raf = window.requestAnimationFrame(update); }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  }

  /* ---------- 6 · Hover magnétique (CTA) ---------- */
  function initMagnets() {
    if (reduce || !window.matchMedia('(pointer: fine)').matches) return;
    document.querySelectorAll('[data-faqx-magnet]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var dx = (e.clientX - r.left - r.width / 2) / (r.width / 2);
        var dy = (e.clientY - r.top - r.height / 2) / (r.height / 2);
        el.style.transform = 'translate(' + (dx * 5).toFixed(1) + 'px,' + (dy * 4).toFixed(1) + 'px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- 7 · Vidéos lazy (hero + bandes) ---------- */
  function initVideos() {
    var vids = document.querySelectorAll('video[data-faqx-video]');
    if (!vids.length) return;
    /* 2026-10-10 : sous mouvement réduit, la vidéo ne serait jamais lancée ; on ne la télécharge pas (l'image d'attente reste). */
    if (reduce) return;
    function hydrate(v) {
      if (v.__hydrated) return;
      v.__hydrated = true;
      var src = v.getAttribute('data-src');
      /* 2026-10-10 : fichier léger sous 750 px quand la bande en fournit un */
      var sm = v.getAttribute('data-src-mobile');
      if (sm && window.matchMedia && window.matchMedia('(max-width: 749px)').matches) src = sm;
      if (!src) return;
      v.src = src;
      v.load();
    }
    function tryPlay(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if (!('IntersectionObserver' in window)) { vids.forEach(hydrate); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { hydrate(v); if (!reduce) tryPlay(v); }
        else if (v.__hydrated && !v.paused) v.pause();
      });
    }, { rootMargin: '240px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  ready(function () {
    if (!document.querySelector('.mw-faqx')) return;
    document.documentElement.classList.add('mw-faqx-js');
    initHero();
    initReveals();
    initSpy();
    initAccordions();
    initParallax();
    initMagnets();
    initVideos();
  });
})();
